import { useEffect } from 'react'
import { useNavigate } from 'react-router'

import { ROUTES } from '@/constants/routes'

import { useProductConfig } from '@/contexts/ProductConfigContext'

import { getOtpPrerequisiteState, OTP_PREREQUISITE_KIND } from '@/utils/otpPrerequisites'

/**
 * Redirects when OTP step prerequisites are missing (user skipped send-OTP flow).
 */
export default function useOtpPrerequisiteGuard(kind, { email } = {}) {
  const navigate = useNavigate()
  const { appendProductParams } = useProductConfig()

  useEffect(() => {
    const { isAllowed } = getOtpPrerequisiteState(kind, email)
    if (isAllowed) return

    const fallbackRoute =
      kind === OTP_PREREQUISITE_KIND.PHONE ? ROUTES.LOGIN : ROUTES.EMAIL_VERIFICATION
    navigate(`${fallbackRoute}?${appendProductParams().toString()}`, { replace: true })
  }, [appendProductParams, email, kind, navigate])
}
